import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";
import { PedidosStorageKeys, useSaurusPedidosStorage } from "../../../../service/app/use-cases/saurus-pedidos-storage";
import { useTokenIntegracaoGestao } from "../../../../service/app/use-cases/token-integracao-gestao";

export function useGetIntegradorRefreshToken() {
  const { invocarApi, ...outrasPropriedades } = useApiBase();
  const { retornaTokenIntegracao } = useTokenIntegracaoGestao();
  const { exists, getRegistro } = useSaurusPedidosStorage();

  const getIntegradorRefreshToken = useCallback(
    async (authToken: string) => {
      await retornaTokenIntegracao(false);

      const tokenIntegracao = exists(PedidosStorageKeys.TokenIntegracao, false)
        ? getRegistro(PedidosStorageKeys.TokenIntegracao, false)
        : "";

      return invocarApi({
        baseURL: VariaveisAmbiente.apiMasterUrl,
        url: "/api/token/integradores/refreshToken",
        method: "GET",
        params: { token: authToken },
        headers: { Authorization: `Bearer ${tokenIntegracao}` },
        enviarTokenUsuario: false,
      });
    },
    [exists, getRegistro, invocarApi, retornaTokenIntegracao],
  );

  return {
    ...outrasPropriedades,
    getIntegradorRefreshToken,
  };
}

